// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Paa-z","narrowOptionButtons":"Qaa-z","noOptions":"Raa-z"};